import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { pilarEmbajadores } from '../sortilegioContent';

const PilarEmbajadores = () => (
  <Box py={{ xs: 8, md: 10 }}>
    <SectionHeader
      overline={pilarEmbajadores.overline}
      title={pilarEmbajadores.title}
      subtitle={pilarEmbajadores.subtitle}
      icon="team"
      align="left"
      maxWidth="100%"
    />
    <Grid container spacing={3}>
      {pilarEmbajadores.items.map((item) => (
        <Grid item xs={12} sm={6} key={item.title}>
          <GlassCard data-aos="fade-up">
            <CardContent sx={{ p: 3, display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <IconBadge icon={item.icon} variant="gradient" size={44} rounded="12px" />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                  {item.text}
                </Typography>
              </Box>
            </CardContent>
          </GlassCard>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default PilarEmbajadores;
